"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.divisionsError = exports.receiveDivisions = exports.receiveDivisionsStarted = exports.DIVISIONS_ERROR = exports.RECEIVE_DIVISIONS = exports.RECEIVE_DIVISIONS_STARTED = void 0;
exports.default = reducer;
exports.loadDivisions = loadDivisions;
const api_1 = require("core/api");
// Actions
exports.RECEIVE_DIVISIONS_STARTED = 'RECEIVE_DIVISIONS_STARTED';
exports.RECEIVE_DIVISIONS = 'RECEIVE_DIVISIONS';
exports.DIVISIONS_ERROR = 'DIVISIONS_ERROR';
// Reducer
const initialState = { divisions: [], divisionsLoaded: false };
function reducer(state = initialState, action = {}) {
    const divisions = action.data;
    switch (action.type) {
        case 'RECEIVE_DIVISIONS_STARTED':
            return {
                ...state,
            };
        case 'RECEIVE_DIVISIONS':
            return {
                ...state,
                divisionsLoaded: true,
                divisions: divisions,
            };
        case 'DIVISIONS_ERROR':
            return {
                ...state,
                divisionsLoaded: false,
                error: action.error,
            };
        default:
            return state;
    }
}
// Action Creators
const receiveDivisionsStarted = () => {
    return { type: exports.RECEIVE_DIVISIONS_STARTED };
};
exports.receiveDivisionsStarted = receiveDivisionsStarted;
const receiveDivisions = (data) => {
    return { type: exports.RECEIVE_DIVISIONS, data };
};
exports.receiveDivisions = receiveDivisions;
const divisionsError = (data) => {
    return { type: exports.DIVISIONS_ERROR, data };
};
exports.divisionsError = divisionsError;
// services
function loadDivisions(memberDivisionIds) {
    return (dispatch) => {
        dispatch((0, exports.receiveDivisionsStarted)());
        return api_1.DivisionService.getDivisions(memberDivisionIds)
            .then((res) => {
            dispatch((0, exports.receiveDivisions)(res));
        })
            .catch((error) => {
            dispatch((0, exports.divisionsError)(error));
        });
    };
}
